var _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRegistryEditor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Registry_Editor_48",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    stroke: "none",
    fill: "#000000",
    opacity: 0
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.92 0 0 0.92 24 24)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {}
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0 -0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,188,212)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-24, -23.5)",
    d: "M 7 16 L 15 16 L 15 24 L 7 24 z M 7 24 L 15 24 L 15 32 L 7 32 z M 15 24 L 23 24 L 23 32 L 15 32 z M 7 32 L 15 32 L 15 40 L 7 40 z M 15 32 L 23 32 L 23 40 L 15 40 z M 23 32 L 31 32 L 31 40 L 23 40 z M 34 7 L 41 7 L 41 14 L 34 14 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.96 0.29 -0.29 -0.96 12.44 -0.21)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,188,212)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-36.44, -23.8)",
    d: "M 33.062 20.418 L 39.817 20.418 L 39.817 27.173 L 33.062 27.173 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.6 0.8 -0.8 -0.6 -0.53 -10.99)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,188,212)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-23.47, -13.01)",
    d: "M 20.169 9.708 L 26.768 9.708 L 26.768 16.307000000000002 L 20.169 16.307000000000002 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -13 -4)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,131,143)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-11, -20)",
    d: "M 16 25 L 6 25 L 6 15 L 16 15 L 16 25 z M 8 23 L 14 23 L 14 17 L 8 17 L 8 23 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -13 4)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,131,143)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-11, -28)",
    d: "M 16 33 L 6 33 L 6 23 L 16 23 L 16 33 z M 8 31 L 14 31 L 14 25 L 8 25 L 8 31 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -5 4)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,131,143)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-19, -28)",
    d: "M 24 33 L 14 33 L 14 23 L 24 23 L 24 33 z M 16 31 L 22 31 L 22 25 L 16 25 L 16 31 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -13 12)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,131,143)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-11, -36)",
    d: "M 16 41 L 6 41 L 6 31 L 16 31 L 16 41 z M 8 39 L 14 39 L 14 33 L 8 33 L 8 39 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -5 12)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,131,143)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-19, -36)",
    d: "M 24 41 L 14 41 L 14 31 L 24 31 L 24 41 z M 16 39 L 22 39 L 22 33 L 16 33 L 16 39 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 5.72 -0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,131,143)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-29.72, -23.5)",
    d: "M 32 41 L 22 41 L 22 31 L 32 31 L 32 41 z M 24 39 L 30 39 L 30 33 L 24 33 L 24 39 z M 42 15 L 33 15 L 33 6 L 42 6 L 42 15 z M 35 13 L 40 13 L 40 8 L 35 8 L 35 13 z M 33.5 29.245 L 30.990000000000002 20.856 L 39.379000000000005 18.347 L 41.889 26.734 L 33.5 29.245 z M 33.48 22.199 L 34.842999999999996 26.755000000000003 L 39.397999999999996 25.393 L 38.035 20.837 L 33.48 22.199 z M 24.299 19.03 L 17.445 13.838000000000001 L 22.637 6.984000000000001 L 29.491 12.176000000000002 L 24.299 19.03 z M 20.247 13.451 L 23.913 16.228 L 26.689 12.562000000000001 L 23.024 9.785 L 20.247 13.451 z",
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegistryEditor);
export default __webpack_public_path__ + "static/media/registry_editor.563c3368855bc7deafdbdda005e93659.svg";
export { ForwardRef as ReactComponent };